import { EthService } from "./web3";

export const PROVIDER = `${process.env.VUE_APP_MAINCHAIN_PROVIDER}`;

class MainChain extends EthService {
  private static bfInternal: MainChain;

  static get Instance(): EthService {
    if (MainChain.bfInternal === undefined) {
      MainChain.bfInternal = new EthService(PROVIDER);
    }
    return MainChain.bfInternal;
  }
}

export default MainChain.Instance;
